import { styled } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';

import { AppDrawerProps } from './types';

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppDrawerProps>(({ theme, open, width }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    padding: '20px 12px',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    borderRadius: 0,
    overflowX: 'hidden',
    ...(!open && {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: '80px',
    }),
  },
  ...(!open && {
    '& .MuiDrawer-paper .MuiButtonBase-root.MuiAccordionSummary-root': {
      justifyContent: 'flex-end',
      paddingLeft: theme.spacing(1),
    },
    '& .MuiDrawer-paper .MuiAccordionSummary-expandIconWrapper': {
      display: 'none',
    },
  }),
  ...(open && {
    '& .MuiListItemButton-root': {
      width: '95%',
      '&.mui-menu-item-active .MuiListItemText-root .MuiTypography-root, &:hover .MuiListItemText-root .MuiTypography-root':
        {
          color: theme.palette.neutral.main,
        },
      '& .MuiListItemText-root .MuiTypography-root': {
        marginLeft: theme.spacing(1.5),
      },
    },
  }),
  '& .MuiListItemText-root': {
    visibility: open ? 'visible' : 'hidden',
    opacity: open ? 1 : 0,
    transition: theme.transitions.create(['opacity', 'visibility'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  '& .MuiToolbar-root': {
    minHeight: 48,
  },
}));
